// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__Hvaqv","Label":"Input_Label__3Mxit","InputElement":"Input_InputElement__355PM","Invalid":"Input_Invalid__dtXqk"};